<template>
  <!--10-2教育机构人才列表查看页面 -->
  <div class="main-css">
    <!--标题-->
    <div class="title-css">{{ $t("talentPool") }}</div>
    <div class="main-box">
      <!-- button 部分 -->
      <div class="line-button-box">
        <el-button class="button-css" @click="handleAddClick">{{
          $t("postingNewTalent")
        }}</el-button>
      </div>
      <!-- table部分 -->
      <div class="table">
        <el-table
          @row-click="jump3"
          ref="multipleTable"
          :data="tableData"
          style="width: 98%"
          :max-height="tableHeight"
          v-loading="loading"
          @selection-change="handleSelectionChange"
          @sort-change="changeTableSort"
        >
          <el-table-column type="selection" width="45"> </el-table-column>
          <!-- ----------------------人材番号---------------------- -->
          <el-table-column
            prop="resumeId"
            label="人材番号"
            min-width="100"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("talentNumber") }}</p>
              <el-input
                v-model="searchData1"
                size="mini"
                placeholder="Search"
                @input="handleEducationResumeInfoFuzzyQuery"
                clearable
              />
            </template>
            <template slot-scope="scope">
              <span
                @click.stop="
                  jump(scope.row.resumeId, scope.row.applicationStatus)
                "
                >{{ scope.row.resumeId }}</span
              >
            </template>
          </el-table-column>
          <!-- ----------------------氏名---------------------- -->
          <el-table-column
            prop="name"
            label="氏名"
            min-width="110"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("name") }}</p>
              <el-input
                v-model="searchData2"
                size="mini"
                placeholder="Search"
                @input="handleEducationResumeInfoFuzzyQuery"
                clearable
              />
            </template>
            <template slot-scope="scope">
              <span
                @click.stop="
                  jump2(
                    scope.row.resumeId,
                    scope.row.applicationStatus,
                    scope.row
                  )
                "
                >{{ scope.row.name }}</span
              >
            </template>
          </el-table-column>
          <!-- ----------------------性別---------------------- -->
          <el-table-column
            prop="sex"
            label="性別"
            min-width="100"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("sex") }}</p>
              <el-dropdown @command="handleCommandSex">
                <span class="el-dropdown-link">
                  {{ sex === "" ? "All" : sex }}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item1, index) in SexData"
                    :key="item1.code"
                    :command="item1"
                    >{{ item1.name }}</el-dropdown-item
                  >
                  <el-dropdown-item command="del">{{
                    $t("cancel")
                  }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template slot-scope="scope">
              <span v-if="language === 'ja-JP'">{{
                scope.row.jpsex_dictText
              }}</span>
              <span v-else>{{ scope.row.sex_dictText }}</span>
            </template>
          </el-table-column>

          <!-- ----------------------就職担当---------------------- -->
          <el-table-column
            prop="principal"
            label="就職担当"
            :show-overflow-tooltip="true"
            min-width="120"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("inauguration") }}</p>
              <div class="el-dropdown-css-1">
                <el-dropdown @command="handleCommandPrincipal">
                  <span class="el-dropdown-link">
                    {{ principal === "" ? "All" : principal }}
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      v-for="(item2, index) in principalData"
                      :key="item2.userId"
                      :command="item2"
                      >{{ item2.userName }}</el-dropdown-item
                    >
                    <el-dropdown-item command="del">{{
                      $t("cancel")
                    }}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
            <template slot-scope="scope">
              {{ scope.row.principal }}
            </template>
          </el-table-column>
          <!-- -----------------------生年月日----------------------- -->
          <el-table-column
            prop="birth"
            label="生年月日"
            min-width="200"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("birth") }}</p>
              <el-date-picker
                v-model="searchData5"
                type="daterange"
                range-separator="~"
                :start-placeholder="$t('deliveryTimein')"
                :end-placeholder="$t('deliveryTimeout')"
                class="data-picker"
                @blur="dataTimeChange"
                @change="pickerChangeFn"
                format="yyyy-MM-dd"
              >
              </el-date-picker>
            </template>
            <template slot-scope="scope">
              {{ scope.row.birth && scope.row.birth.split(" ")[0] }}
            </template>
          </el-table-column>
          <!-- ------------------------学歴------------------------ -->
          <el-table-column
            prop="education"
            label="学歴"
            min-width="130"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("educationalBackgroundMatter") }}</p>
              <div class="el-dropdown-css-2">
                <el-dropdown @command="handleCommandeducation">
                  <span class="el-dropdown-link">
                    {{ education === "" ? "All" : education
                    }}<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      v-for="(item, index) in educationData"
                      :key="item.code"
                      :command="item"
                      >{{ item.name }}</el-dropdown-item
                    >
                    <el-dropdown-item command="del">{{
                      $t("cancel")
                    }}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
            <template slot-scope="scope">
              <span v-if="language === 'ja-JP'">{{
                scope.row.jpeducation_dictText
              }}</span>
              <span v-else>{{ scope.row.education_dictText }}</span>
            </template>
          </el-table-column>
          <!-- --------------------------専攻-------------------------- -->
          <el-table-column
            prop="profession"
            label="専攻"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("major") }}</p>
              <el-input
                v-model="searchData7"
                size="mini"
                placeholder="Search"
                @input="handleEducationResumeInfoFuzzyQuery"
                clearable
              />
            </template>
            <template slot-scope="scope">
              {{ scope.row.profession }}
            </template>
          </el-table-column>
          <!-- --------------------------日本語-------------------------- -->
          <el-table-column
            prop="japanese"
            label="日本語"
            min-width="120"
            sortable
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("japaneseVs") }}</p>
              <div class="el-dropdown-css-3">
                <el-dropdown @command="handleCommandJapanese">
                  <span class="el-dropdown-link">
                    {{ jp === "" ? "All" : jp }}
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      v-for="(item, index) in jpdate"
                      :key="item.code"
                      :command="item"
                      >{{ item.name }}
                    </el-dropdown-item>
                    <el-dropdown-item command="del">{{
                      $t("cancel")
                    }}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
            <template slot-scope="scope">
              <span v-if="language === 'ja-JP'">{{
                scope.row.jpjapanese_dictText
              }}</span>
              <span v-else>{{ scope.row.japanese_dictText }}</span>
            </template>
          </el-table-column>
          <!-- --------------------------観覧回数-------------------------- -->
          <el-table-column
            prop="visitedTime"
            label="観覧回数"
            min-width="100"
            sortable
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p class="operate">{{ $t("numberOfVisits") }}</p>
            </template>
            <template slot-scope="scope">
              {{ scope.row.visitedTime }}
            </template>
          </el-table-column>
          <!-- --------------------------状态-------------------------- -->
          <el-table-column
            prop="applicationStatus"
            label="観覧回数"
            min-width="100"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p class="operate">{{ $t("status") }}</p>
            </template>
            <template slot-scope="scope">
              <span v-if="language === 'ja-JP'">{{
                scope.row.jpapplicationStatus_dictText
              }}</span>
              <span v-else>{{ scope.row.applicationStatus_dictText }}</span>
            </template>
          </el-table-column>
          <!-- --------------------------操作-------------------------- -->
          <el-table-column label="操作" fixed="right" min-width="150">
            <template slot="header">
              <p class="operate">{{ $t("operate") }}</p>
            </template>
            <template slot-scope="scope">
              <el-dropdown @command="handleStatus">
                <el-button type="primary" class="save-button">
                  {{ $t("changeState") }}
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in StatusData"
                    :key="item.code"
                    :command="beforeHandleCommand(item, scope.row.resumeId)"
                    >{{ item.name }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 个人简历弹出层 -->
      <el-dialog
        :title="$t('jobView')"
        class="selfDialog"
        :visible.sync="addDialogVisible"
        width="30%"
      >
        <div class="left-box">
          <!-- 主要信息部分 -->
          <div class="main-left-box">
            <!-- 显示图片 -->
            <div class="case-img">
              <!--图片未传-->
              <div class="one-box-left1">
                <img
                  :src="img"
                  alt=""
                  @error="
                    e => {
                      e.target.src = require('@/assets/defaultImg.png');
                    }
                  "
                />
              </div>
              <div class="one-box-left2">
                <div class="one-box-left-line1">
                  <div class="one-box-left-line-smallleft">
                    <p></p>
                  </div>
                  <div class="one-box-left-line-smallright">
                    <p>{{ infoList.anonym }}</p>
                  </div>
                </div>
                <div class="one-box-left-line2">
                  <div class="one-box-left-line-smallleft">
                    <p>{{ $t("name") }}</p>
                  </div>
                  <div class="one-box-left-line-smallright">
                    <p>{{ infoList.name }}</p>
                  </div>
                </div>
                <div class="one-box-left-line3">
                  <div class="one-box-left-line-smallleft">
                    <p>{{ $t("sex") }}</p>
                  </div>
                  <div class="one-box-left-line-smallright">
                    <span v-if="language == 'ja-JP'">{{
                      this.infoList.jpsex_dictText
                    }}</span>
                    <span v-else>{{ this.infoList.sex_dictText }}</span>
                  </div>
                </div>
                <div class="one-box-left-line4">
                  <div class="one-box-left-line-smallleft">
                    <p>{{ $t("birth") }}</p>
                  </div>
                  <div class="one-box-left-line-smallright">
                    <p>{{ infoList.birth && infoList.birth.split(" ")[0] }}</p>
                  </div>
                </div>
              </div>
            </div>
            <!-- 标签部分 -->
            <div class="label">
              <!--qaq-->
              <div class="label-box-active" v-if="this.infoList.label1 == 1">
                <div v-if="language == 'ja-JP'">
                  {{ this.infoList.jplabel1_dictText }}
                </div>
                <div v-else>{{ this.infoList.label1_dictText }}</div>
              </div>
              <div class="label-box-active" v-if="this.infoList.label2 == 1">
                <div v-if="language == 'ja-JP'">
                  {{ this.infoList.jplabel2_dictText }}
                </div>
                <div v-else>{{ this.infoList.label2_dictText }}</div>
              </div>
              <div class="label-box-active" v-if="this.infoList.label3 == 1">
                <div v-if="language == 'ja-JP'">
                  {{ this.infoList.jplabel3_dictText }}
                </div>
                <div v-else>{{ this.infoList.label3_dictText }}</div>
              </div>
              <div class="label-box-active" v-if="this.infoList.label1 == 1">
                <div v-if="language == 'ja-JP'">
                  {{ this.infoList.jplabel1_dictText }}
                </div>
                <div v-else>{{ this.infoList.label1_dictText }}</div>
              </div>
            </div>
            <!-- 第一行 -->
            <div class="inline-box">
              <div class="inline-left">
                <div class="inline-left-title">{{ $t("contactAddress") }}</div>
                <div class="inline-left-title-main">
                  {{ $t("currentAddress") }}
                  <div
                    class="inline-left-title-main-right"
                    :title="infoList.address"
                  >
                    {{ infoList.address }}
                  </div>
                </div>

                <div class="inline-left-title-main">
                  {{ $t("email") }}
                  <div
                    class="inline-left-title-main-right"
                    :title="infoList.email"
                  >
                    {{ infoList.email }}
                  </div>
                </div>

                <div class="inline-left-title-main">
                  {{ $t("telephoneNumber") }}
                  <div class="inline-left-title-main-right">
                    {{ infoList.telephone }}
                  </div>
                </div>
              </div>
              <div class="inline-right">
                <div class="inline-left-title">{{ $t("education") }}</div>

                <div class="inline-left-title-main">
                  {{ $t("period") }}
                  <div class="inline-left-title-main-right-long">
                    {{
                      infoList.enrollment && infoList.enrollment.split(" ")[0]
                    }}~{{
                      infoList.enrollment && infoList.graduation.split(" ")[0]
                    }}
                  </div>
                </div>

                <div class="inline-left-title-main">
                  {{ $t("school") }}
                  <div
                    class="inline-left-title-main-right"
                    :title="infoList.school"
                  >
                    {{ infoList.school }}
                  </div>
                </div>

                <div class="inline-left-title-main">
                  {{ $t("major") }}
                  <div class="inline-left-title-main-right">
                    {{ infoList.profession }}
                  </div>
                </div>
              </div>
            </div>
            <!-- 第二行 -->
            <div class="inline-box">
              <div class="inline-left">
                <div class="inline-left-title">{{ $t("qualification") }}</div>
                <div class="inline-left-title-main">
                  {{ infoList.qualification1 }}
                </div>

                <div class="inline-left-title-main">
                  {{ infoList.qualification2 }}
                </div>

                <div class="inline-left-title-main">
                  {{ infoList.qualification3 }}
                </div>
              </div>
              <div class="inline-right">
                <div class="inline-left-title">{{ $t("workHistory") }}</div>
                <div class="inline-left-title-main">
                  {{ $t("period") }}
                  <div class="inline-left-title-main-right-long">
                    {{ infoList.startYear && infoList.startYear.split(" ")[0] }}
                    &#12288;
                    {{ infoList.endYear && infoList.endYear.split(" ")[0] }}
                  </div>
                </div>

                <div class="inline-left-title-main">
                  {{ $t("companyName") }}
                  <div
                    class="inline-left-title-main-right"
                    :title="infoList.hopeWorkplace"
                  >
                    {{ infoList.hopeWorkplace }}
                  </div>
                </div>

                <div class="inline-left-title-main">
                  {{ $t("affiliation") }}
                  <div class="inline-left-title-main-right">
                    {{ infoList.type }}
                  </div>
                </div>
              </div>
            </div>
            <!-- 第三行 -->
            <div class="inline-box">
              <div class="inline-left">
                <div class="inline-left-title">{{ $t("languageSkills") }}</div>
                <div class="inline-left-title-main">
                  {{ $t("japanese") }}
                  <div class="inline-left-title-main-right">
                    <span v-if="language == 'ja-JP'">{{
                      this.infoList.jpjapanese_dictText
                    }}</span>
                    <span v-else>{{ this.infoList.japanese_dictText }}</span>
                  </div>
                </div>

                <div class="inline-left-title-main">
                  {{ $t("english") }}
                  <div class="inline-left-title-main-right">
                    <span v-if="language == 'ja-JP'">{{
                      this.infoList.jpenglish_dictText
                    }}</span>
                    <span v-else>{{ this.infoList.english_dictText }}</span>
                  </div>
                </div>

                <div class="inline-left-title-main">
                  {{ $t("other") }}
                  <div class="inline-left-title-main-right">
                    {{ infoList.other }}
                  </div>
                </div>
              </div>
              <div class="inline-right">
                <div class="inline-left-title">{{ $t("request") }}</div>

                <div class="inline-left-title-main-long">
                  {{ $t("joinCompany") }}
                  <div class="inline-left-title-main-right-long">
                    {{
                      infoList.startYear && infoList.startYear.split(" ")[0]
                    }}~{{ infoList.endYear && infoList.endYear.split(" ")[0] }}
                  </div>
                </div>

                <div class="inline-left-title-main">
                  {{ $t("workLocation") }}
                  <div
                    class="inline-left-title-main-right"
                    :title="infoList.workPlace"
                  >
                    {{ infoList.workPlace }}
                  </div>
                </div>

                <div class="inline-left-title-main">
                  {{ $t("occupation") }}
                  <div class="inline-left-title-main-right">
                    {{ infoList.profession }}
                  </div>
                </div>
              </div>
            </div>

            <!-- 第五行 -->
            <div class="inline-log-box">
              <div class="long-box-title">{{ $t("selfPR") }}</div>
              <div class="long-box-main">
                {{ infoList.pr }}
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
      <!-- 分页部分 -->
      <div class="pagination">
        <div class="pagination-main">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            layout=" prev, pager, next"
            :total="totalItem"
            :page-size="pageSize"
          >
          </el-pagination>
          <!-- Rows per page -->
          <div class="rowsPage">
            <span>Rows per page</span>
            <div class="rowsPage-css">
              <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                  {{ pageSize
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a">7</el-dropdown-item>
                  <el-dropdown-item command="b">15</el-dropdown-item>
                  <el-dropdown-item command="c">20</el-dropdown-item>
                  <el-dropdown-item command="d">25</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  educationResumeInfoFuzzyQuery,
  educationResumeInfoQuery,
  educationUserInfoQuery,
  fuzzyApplyResumeInfo,
  getUrlFromOSS,
  queryApplyResumeInfo,
  resumeDetailQuery,
  resumeQuery,
  resumeResponsibleUpdate,
  resumeStatusUpdate,
  resumeUpdateStatus
} from "../../js/api";
import AES from "../../js/AES";
import axios from "axios";

export default {
  name: "educationalInstitutionTalentListView",
  components: {},
  data() {
    return {
      anonym: "",
      inputData1: "", //搜索框input内容
      tableData: [],
      searchData1: "", //表格第一个搜索
      searchData2: "", //表格第二个搜索
      searchData3: "", //表格第三个搜索
      searchData4: "", //表格第四个搜索
      searchData5: "", //表格第五个搜索
      searchData6: "", //表格第六个搜索
      searchData7: "", //表格第七个搜索
      searchData8: "", //表格第八个搜索
      searchData9: "", //表格第九个搜索
      dropdownData1: "", //第一个下拉
      infoList: [],
      currentPage: 1, //页数
      pageSize: 7, //每页条数
      total: 100,
      loading: false, //table loading
      label1: true,
      label2: true,
      label3: true,
      label4: true,
      searchDataStart: "",
      dialogPersonalResumeShow: true, //dialog个人简历
      addDialogVisible: false,
      StatusData: [],
      SexData: [],
      principalData: [],
      statusCode: "",
      sexCode: "",
      principalCode: "",
      resumeIdList: "",
      resumeId: "",
      educationId: "",
      birthEnd: "",
      birthStart: "",
      applicationStatus: "",
      totalItem: 0,
      language: "",
      sex: "",
      principal: "",
      img: "",
      jp: "ALL",
      jpdate: [],
      education: "",
      educationName: "All",
      educationCode: "",
      educationData: [],
      tableHeight: "" //表格高度
    };
  },
  created() {
    this.language = this.$i18n.locale;
    this.searchDataStart = this.$route.query.searchData;
    this.resumeId = this.$route.query.resumeId;
    this.educationId = this.$route.query.educationId;

    console.log(this.searchDataStart);
    this.getEducationUserInfoQuery();
    this.getEducationResumeInfoQuery();
    this.getApplyStatus();
    this.getSex();
    this.getJapanese();
    this.geteducation();
    this.getTableHeight();
  },
  //qaq
  mounted() {
    window.addEventListener("setItemEvent", this.languageChange, true);
    //挂载window.onresize事件(动态设置table高度)
    let _this = this;
    window.onresize = () => {
      if (_this.resizeFlag) {
        clearTimeout(_this.resizeFlag);
      }
      _this.resizeFlag = setTimeout(() => {
        _this.getTableHeight();
        _this.resizeFlag = null;
      }, 100);
    };
  },
  destroyed() {
    window.removeEventListener("setItemEvent", this.languageChange, true);
  },
  computed: {},
  methods: {
    //获取表格高度
    getTableHeight() {
      let tableH = 340; //距离页面下方的高度
      let tableHeightDetil = window.innerHeight - tableH;
      if (tableHeightDetil <= 200) {
        this.tableHeight = 200;
      } else {
        this.tableHeight = window.innerHeight - tableH;
      }
    },

    //判断是模糊查询还是准确查询
    morq() {
      if (
        this.birthEnd === "" &&
        this.birthStart === "" &&
        this.education === "" &&
        this.jpCode === "" &&
        this.searchData2 === "" &&
        this.principal === "ALL" &&
        this.searchData1 === "" &&
        this.searchData7 === "" &&
        this.sexCode === ""
      ) {
        this.getEducationResumeInfoQuery();
      } else {
        this.handleEducationResumeInfoFuzzyQuery();
      }
    },
    getJapanese() {
      var that = this;
      var dataItems = "";
      if (that.language === "ja-JP") {
        dataItems = "jpjapanese";
      } else {
        dataItems = "japanese";
      }
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: dataItems
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000" || res.data.code === "C0252") {
            console.log("--------获取数据字典接口数据sex--------");
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.jpdate = aesFecInfo.data;
            console.log(that.jpdate);
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    },
    //qaq
    languageChange(e) {
      const that = this;
      console.log("------监听数据6------");
      console.log(e);
      if (e.key && e.key == "language" && e.newValue) {
        that.language = that.$i18n.locale;
        that.morq();
        that.getEducationUserInfoQuery();
        that.getApplyStatus();
        that.getSex();
        that.getJapanese();
        that.geteducation();
      }
    },
    //图片回显
    getUrl(url) {
      console.log("url" + url);
      var fakeInfo = {
        message: url
      };
      getUrlFromOSS(fakeInfo)
        .then(res => {
          if (res.data.code === "200 OK") {
            console.log("图片回显接口1");
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.img = aesFecInfo.message;
          } else {
            console.log(res);
          }
        })
        .catch(() => {});
    },
    //编辑中点击 id 跳转至修改页面 0:7-7
    jump(resumeId, applicationStatus, row) {
      if (applicationStatus === 0) {
        this.$router.push({
          path: "/userEducationInstitutionsToModifyTheSchedule1",
          name: "userEducationInstitutionsToModifyTheSchedule1",
          params: { resumeId: resumeId }
        });
      }
    },
    //点击 名 进入人才详情弹窗
    jump2(resumeId, applicationStatus, row) {
      if (applicationStatus !== 0) {
        this.getResumeDetailQuery(resumeId);
        this.addDialogVisible = true;
      } else {
        this.$router.push({
          name: "userEducationInstitutionsToModifyTheSchedule1",
          params: { resumeId: resumeId }
        });
      }
    },
    //点击 行 进入11-3
    jump3(row) {
      if (row.applicationStatus !== 0) {
        this.$router.push({
          path: "/educationalInstitutionsTalentApplicationList",
          name: "educationalInstitutionsTalentApplicationList",
          params: { row: row }
        });
      } else {
        this.$router.push({
          name: "userEducationInstitutionsToModifyTheSchedule1",
          params: { resumeId: row.resumeId }
        });
      }
    },
    handleCommandSex(evt) {
      if (evt === "del") {
        this.sexCode = "";
        this.sex = "";
      } else {
        this.sexCode = evt.code;
        this.sex = evt.name;
      }
      this.handleEducationResumeInfoFuzzyQuery();
    },
    handleCommandPrincipal(evt) {
      if (evt === "del") {
        this.principal = "";
      } else {
        this.principal = evt.userName;
      }
      this.handleEducationResumeInfoFuzzyQuery();
      console.log(evt);
    },
    //获取education下拉
    handleCommandeducation(evt) {
      if (evt === "del") {
        this.educationCode = "";
        this.education = "";
      } else {
        this.educationCode = evt.code;
        this.education = evt.name;
      }
      this.handleEducationResumeInfoFuzzyQuery();
    },
    handleChangePrincipal(evt) {
      this.handleResumeResponsibleUpdate(evt);
    },
    handleCommandStatus(evt) {
      this.statusCode = evt.code;
      this.status = evt.name;
    },
    handleCommandJapanese(evt) {
      if (evt === "del") {
        this.jpCode = "";
        this.jp = "";
      } else {
        this.jpCode = evt.code;
        this.jp = evt.name;
      }
      console.log(evt);
      this.handleEducationResumeInfoFuzzyQuery();
    },
    //将id写进command
    beforeHandleCommand(item, id) {
      return {
        item: item,
        id: id
      };
    },
    //table排序
    changeTableSort(column) {
      console.log(column);
      if (column.prop === "minimum") {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["minimum"] - b["minimum"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["minimum"] - a["minimum"]
          );
        }
      } else if (column.prop === "maximumAmount") {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["maximumAmount"] - b["maximumAmount"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["maximumAmount"] - a["maximumAmount"]
          );
        }
      } else if (column.prop === "pageView") {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["pageView"] - b["pageView"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["pageView"] - a["pageView"]
          );
        }
      }
    },
    //data -time 选择
    dataTimeChange() {
      console.log(this.searchData5);
      this.birthStart = this.timeJs(this.searchData5[0]);
      this.birthEnd = this.timeJs(this.searchData5[1]);
      //模糊查询
      this.handleEducationResumeInfoFuzzyQuery();
    },
    timeJs(date) {
      //获取年份
      var y = date.getFullYear();
      //获取月份  返回0-11
      var m = date.getMonth() + 1;
      // 获取日
      var d = date.getDate();
      //获取星期几  返回0-6   (0=星期天)
      var w = date.getDay();
      //星期几
      var ww = " 星期" + "日一二三四五六".charAt(date.getDay());
      //时
      var h = date.getHours();
      //分
      var minute = date.getMinutes();
      //秒
      var s = date.getSeconds();
      //毫秒
      var sss = date.getMilliseconds();

      if (m < 10) {
        m = "0" + m;
      }
      if (d < 10) {
        d = "0" + d;
      }
      if (h < 10) {
        h = "0" + h;
      }
      if (minute < 10) {
        minute = "0" + minute;
      }
      if (s < 10) {
        s = "0" + s;
      }
      if (sss < 10) {
        sss = "00" + sss;
      } else if (sss < 100) {
        sss = "0" + sss;
      }
      return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + s;
    },
    //清空时间
    pickerChangeFn(value) {
      if (value === null) {
        this.birthStart = "";
        this.birthEnd = "";
        this.handleEducationResumeInfoFuzzyQuery();
      }
    },
    handleCurrentChange(evt) {
      this.currentPage = evt;
      console.log(this.currentPage);
      this.morq();
    },
    //每页条数下拉框
    handleCommand(command) {
      this.currentPage = 1;
      if (command === "a") {
        this.pageSize = 7;
        console.log(this.pageSize);
      } else if (command === "b") {
        this.pageSize = 15;
        console.log(this.pageSize);
      } else if (command === "c") {
        this.pageSize = 20;
        console.log(this.pageSize);
      } else if (command === "d") {
        this.pageSize = 25;
        console.log(this.pageSize);
      }
      this.getEducationResumeInfoQuery();
    },
    //选中
    handleSelectionChange(val) {
      this.multipleSelection = val;
      // console.log(this.multipleSelection);
      this.resumeIdList = [];
      if (this.multipleSelection.length === 1) {
        this.resumeIdList = this.multipleSelection[0].resumeId;
      }
    },
    handleAddClick() {
      console.log("＋新たなbutton");
      this.$router.push({
        path: "/educationAdminTalentAddOne",
        name: "educationAdminTalentAdd1"
      });
    },
    //   标签高亮显示
    labelIsShow(num) {
      if (num === 1) {
        this.label1 = false;
        this.labelListLength(1);
      } else if (num === 2) {
        this.label2 = false;
        this.labelListLength(2);
      } else if (num === 3) {
        this.label3 = false;
        this.labelListLength(3);
      } else if (num === 4) {
        this.label4 = false;
        this.labelListLength(4);
      }
    },
    //判断labelListHandle长度 并且去重方法
    labelListLength(num) {
      if (this.labelListHandle.length < 4) {
        if (num === 1) {
          if (this.labelListHandle.indexOf("外国人歓迎") === -1) {
            this.labelListAdd(1);
          } else {
            return;
          }
        } else if (num === 2) {
          if (this.labelListHandle.indexOf("未経験 OK") === -1) {
            this.labelListAdd(2);
          } else {
            return;
          }
        } else if (num === 3) {
          if (this.labelListHandle.indexOf("新卒 OK") === -1) {
            this.labelListAdd(3);
          } else {
            return;
          }
        } else if (num === 4) {
          if (this.labelListHandle.indexOf("学歴問わない") === -1) {
            this.labelListAdd(4);
          } else {
            return;
          }
        } else {
          return;
        }
      }
    },
    //labelListHandle  push 方法
    labelListAdd(num) {
      if (num === 1) {
        this.labelListHandle.push("外国人歓迎");
      } else if (num === 2) {
        this.labelListHandle.push("未経験 OK");
      } else if (num === 3) {
        this.labelListHandle.push("新卒 OK");
      } else if (num === 4) {
        this.labelListHandle.push("学歴問わない");
      } else {
        return;
      }
      console.log(this.labelListHandle);
    },
    //标签删除方法
    labelDel(num) {
      if (num === 1) {
        for (var i = 0; i < this.labelListHandle.length; i++) {
          if (this.labelListHandle[i] === "外国人歓迎") {
            this.labelListHandle.splice(i, 1);
            this.label1 = true;
            console.log("关闭 外国人歓迎 标签");
          }
        }
      } else if (num === 2) {
        for (var i = 0; i < this.labelListHandle.length; i++) {
          if (this.labelListHandle[i] === "未経験 OK") {
            this.labelListHandle.splice(i, 1);
            this.label2 = true;
            console.log("关闭 未経験 OK 标签");
          }
        }
      } else if (num === 3) {
        for (var i = 0; i < this.labelListHandle.length; i++) {
          if (this.labelListHandle[i] === "新卒 OK") {
            this.labelListHandle.splice(i, 1);
            this.label3 = true;
            console.log("关闭 新卒 OK 标签");
          }
        }
      } else if (num === 4) {
        for (var i = 0; i < this.labelListHandle.length; i++) {
          if (this.labelListHandle[i] === "学歴問わない") {
            this.labelListHandle.splice(i, 1);
            this.label4 = true;
            console.log("关闭 学歴問わない 标签");
          }
        }
      }
      console.log(this.labelListHandle);
    },
    //dialog关闭
    handleCloseDialog() {
      this.dialogPersonalResumeShow = false;
    },

    //修改人才状态
    handleStatus(evt) {
      var fescInfo = {
        status: parseInt(evt.item.code) + 1,
        resumeId: evt.id
      };
      resumeUpdateStatus(fescInfo)
        .then(res => {
          console.log("--------修改人才状态信息接口数据--------");
          console.log(res);
          if (res.data.code === "A0000") {
            this.getEducationResumeInfoQuery();
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            if (aesFecInfo.message === "修改成功") {
              this.$message.success({
                message: "修改成功"
              });
            } else {
              this.$message({
                message: aesFecInfo.message,
                type: "warning"
              });
            }
          }
        })
        .catch(res => {
          console.log("修改人才状态接口异常:", res);
        });
    },
    //个人简历dialog出现
    personalResume() {
      this.dialogPersonalResumeShow = true;
    },
    //接口
    //当前教育机构人才信息查询 总
    getEducationResumeInfoQuery() {
      var pageDTO = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize
      };
      educationResumeInfoQuery(pageDTO)
        .then(res => {
          console.log("--------当前教育机构人才信息查询接口数据--------");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            //this.infoList=aesFecInfo
            this.tableData = aesFecInfo.data;
            this.totalItem = aesFecInfo.total;
            // console.log(this.tableData)
          } else if (res.data.code === 10001) {
            // 审核未通过
            window.location.href = "#/userFailure";
          }
        })
        .catch(res => {
          console.log("当前教育机构人才信息查询接口异常:", res);
        });
    },
    //应聘人才信息模糊查询
    handleEducationResumeInfoFuzzyQuery() {
      var resumeFuzzyQueryDTO = {
        birthEnd: this.birthEnd,
        birthStart: this.birthStart,
        education: this.educationCode,
        japanese: this.jpCode,
        name: this.searchData2,
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        principal: this.principal,
        profession: this.searchData7,
        resumeId: this.searchData1,
        sex: this.sexCode
      };
      if (this.principal === "ALL") {
        resumeFuzzyQueryDTO.principal = "";
      }
      educationResumeInfoFuzzyQuery(resumeFuzzyQueryDTO)
        .then(res => {
          console.log("--------应聘人才信息模糊查询接口数据--------");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            //this.infoList=aesFecInfo
            this.tableData = aesFecInfo.data;
            console.log(this.tableData);
            this.totalItem = aesFecInfo.total;
          }
        })
        .catch(res => {
          console.log("应聘人才信息模糊查询接口异常:", res);
        });
    },
    //当前教育机构下用户信息查询 担当人
    getEducationUserInfoQuery() {
      educationUserInfoQuery()
        .then(res => {
          console.log("--------当前教育机构下用户信息查询接口数据--------");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo.data);
            this.principalData = aesFecInfo.data;
          }
        })
        .catch(res => {
          console.log("当前教育机构下用户信息查询接口异常:", res);
        });
    },
    //通过人才id查看人才详细信息
    getResumeDetailQuery(resumeId) {
      var fescInfo = {
        //  resumeId:"2da41ebca92545388edb89ce3f513vcb",
        resumeId: resumeId
      };
      resumeDetailQuery(fescInfo)
        .then(res => {
          console.log("--------通过人才id查看人才详细信息接口数据--------");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.infoList = aesFecInfo.data[0];
            this.getUrl(this.infoList.avatar);
          }
        })
        .catch(res => {
          console.log("通过人才id查看人才详细信息接口异常:", res);
        });
    },
    //修改人才担当者
    handleResumeResponsibleUpdate(evt) {
      var that = this;
      const params = new URLSearchParams();
      params.append("resumeId", evt.id);
      params.append("userId", evt.item.userId);
      axios
        .post(
          "/api/modules-parent/educationalInstitutionTalentInfo/resumeResponsibleUpdate",
          params,
          {
            headers: {
              //头部参数
              "Content-Type": "application/x-www-form-urlencoded",
              token: localStorage.getItem("token")
            }
          }
        )
        .then(function(res) {
          //请求成功
          console.log("--------修改人才担当者接口数据--------");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));

            that.$message({
              message: "更新成功",
              type: "success"
            });
            that.getEducationResumeInfoQuery();
          } else {
            that.$message({
              message: "更新失败",
              type: "warning"
            });
          }
        })
        .catch(function(error) {
          //请求失败
          console.log(error);
        });
    },
    geteducation() {
      var that = this;
      var dataItems = "";
      if (that.language === "ja-JP") {
        dataItems = "jpeducation";
      } else {
        dataItems = "education";
      }
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: dataItems
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000" || res.data.code === "C0252") {
            console.log("--------获取数据字典接口数据education--------");
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.educationData = aesFecInfo.data;
            console.log("--------获当然是看获取的状态了--------");
            console.log(that.educationData);
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    },
    getApplyStatus() {
      var that = this;
      var dataItems = "";
      if (that.language === "ja-JP") {
        dataItems = "jpresumeStatusChange";
      } else {
        dataItems = "resumeStatusChange";
      }
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: dataItems
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000" || res.data.code === "C0252") {
            console.log(
              "--------获取数据字典接口数据resumeStatusChange--------"
            );
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.StatusData = aesFecInfo.data;
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    },
    getSex() {
      var that = this;
      var dataItems = "";
      if (that.language === "ja-JP") {
        dataItems = "jpsex";
      } else {
        dataItems = "sex";
      }
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: dataItems
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000" || res.data.code === "C0252") {
            console.log("--------获取数据字典接口数据sex--------");
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.SexData = aesFecInfo.data;
            console.log(that.SexData);
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    }
  }
};
</script>
<style scoped>
.main-css {
  width: 100%;
  height: 100%;
  position: relative;
}

.main-box {
  margin-top: 0px;
  width: 100%;
  padding: 0 40px 0 80px;
  box-sizing: border-box;
}

.table /deep/ .el-date-editor {
  width: 210px;
}

.selfDialog /deep/ .el-dialog {
  min-width: 600px !important;
}

.left-box {
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
}

.top-title {
  height: 40px;
  width: 530px;
  display: flex;
  justify-content: center;
  align-content: center;
}

.case-num {
  padding: 0 10px;
  height: 24px;
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 4px;
  text-align: center;
  line-height: 22px;
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: -0.02em;
  color: #686868;
  margin-top: 10px;
  float: right;
  margin-left: 5px;
}

.main-left-box {
  /*overflow-y: scroll;*/
  overflow-y: hidden;
}

.case-img {
  margin-top: 40px;
  width: 100%;
  height: 114px;
  display: flex;
  justify-content: space-between;
}

.label {
  width: 100%;
  height: 26px;
  margin-top: 20px;
}

.inline-left {
  width: 200px;
  height: 130px;
  margin-right: 45px;
  float: left;
  /*background: #51abff;*/
}

.inline-left-title {
  width: 100%;
  height: 30px;
  line-height: 30px;
  font-weight: 700;
  font-size: 14px;
  color: #686868;
  border-bottom: 1px solid #686868;
  /*background:yellow;*/
}

.inline-left-title-main {
  width: 100%;
  min-width: 140px;
  height: 30px;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #686868;
  /*background: peru;*/
}

.inline-left-title-main-long {
  width: 100%;
  height: 30px;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #686868;
  /*background: peru;*/
}

.inline-left-title-main-right {
  width: calc(100% - 60px);
  /* line-height: 50px; */
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #686868;
  float: right;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.inline-left-title-main-right-long {
  width: calc(100% - 60px);
  font-weight: 400;
  font-size: 12px;
  letter-spacing: 0.25px;
  color: #686868;
  float: right;
}

.inline-box {
  height: 60px;
  width: 100%;
  margin-top: 10px;
}

.inline-log-box {
  margin-top: 10px;
  width: 100%;
  min-height: 140px;
}

.long-box-title {
  /*height: 360px;*/
  line-height: 30px;
  width: 485px;
  font-weight: 700;
  font-size: 14px;
  color: #686868;
  border-bottom: 1px solid #686868;
}

.long-box-main {
  width: 485px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #686868;
  /* display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4; */
  /* overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; */
}

.label-box {
  padding: 0 5px;
  background: #b2b2b2;
  border-radius: 4px;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #ffffff;
  float: left;
  margin-right: 20px;
}

.case-img img {
  width: 150px;
  height: 114px;
}

.one-box-left1 {
  width: 200px;
  height: 70%;
  padding-left: 20px;
  padding-top: 5px;
  box-sizing: border-box;
  display: flex;
  justify-content: left;
}

.one-box-left2 {
  width: 600px;
  height: 100px;
  background: #ffffff;
  border-radius: 4px;
  margin: auto;
}

.one-box-left-line1 {
  width: 80%;
  height: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.one-box-left-line2 {
  width: 80%;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.one-box-left-line3 {
  width: 80%;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.one-box-left-line4 {
  width: 90%;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.one-box-left-line-smallleft {
  width: 20%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  /* or 171% */
  display: flex;
  align-items: center;
  /* 灰色字体 */
  color: #686868;
}

.one-box-left-line-smallright {
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  /* or 143% */

  display: flex;
  align-items: center;

  /* 灰色字体 */

  color: #686868;
}

.label-box-active {
  float: left;
  height: 24px;
  padding: 0 5px;
  line-height: 24px;
  background: #51abff;
  border-radius: 4px;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
  overflow: hidden;
  margin-right: 20px;
}

.label-box-active span {
  height: 13px;
  width: 13px;
  background: #fff;
  border-radius: 50%;
  line-height: 13px;
  text-align: center;
  margin-left: 10px;
  display: inline-block;
  color: #b2b2b2;
}

.label-box span {
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #fff;
  line-height: 14px;
  color: #b2b2b2;
  text-align: center;
  margin-left: 10px;
  cursor: pointer;
}

.title-css {
  /*标题样式*/
  font-family: "lucida sans unicode", "lucida grande", sans-serif;
  /*字体*/
  color: #686868;
  /*字体颜色*/
  font-size: 2em;
  /*字体大小*/
  text-align: center;
  /*对齐方式*/
  line-height: 76px;
  /*行间距*/
  margin-top: 10px;
}

.line-button-box {
  height: 40px;
  width: 100%;
  display: flex;
  margin-top: 25px;
  margin-left: 40px;
}

.button-css {
  width: 150px;
  height: 35px;
  background: #51abff;
  box-sizing: border-box;
  border-radius: 4px;
  font-weight: 500;
  font-size: 12px;
  color: #fff;
  margin-right: 25px;
}

.search {
  width: 100%;
  height: 25px;
  display: flex;
}

.search /deep/ .el-input__inner {
  width: 314px;
  height: 24px;
}

.search /deep/ .el-input {
  width: 314px;
  height: 24px;
  line-height: 24px;
  box-sizing: border-box;
}

.search /deep/ .el-input__icon {
  line-height: 24px;
}

.save-button {
  height: 36px;
  background: #fff;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 10px;
  color: #51abff;
  cursor: pointer;
  margin-right: 10px;
}

.search button {
  width: 85px;
  height: 24px;
  line-height: 24px;
  background: #fafafa;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  color: #51abff;
  cursor: pointer;
  margin-left: 20px;
}

.table {
  width: 100%;
  margin-top: 20px;
}

.table /deep/ .el-input__inner {
  border: 1px solid transparent;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #c9cfda;
  padding: 0;
  text-align: center;
}

.operate {
  height: 51px;
}

.table /deep/ .el-dropdown {
  width: 60px;
}

.table-img-css {
  border-radius: 50%;
}

.el-dropdown-link2 {
  cursor: pointer;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  margin-left: -26px;
  width: 100%;
  display: inline-block;
}

.table /deep/ .el-icon-arrow-down {
  float: right;
  height: 20px;
  line-height: 20px;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.table /deep/ .el-table__cell {
  position: relative;
  text-align: center;
}

.table /deep/ .caret-wrapper {
  display: inline-block;
  position: absolute;
  top: -5px;
  right: -20px;
  width: 67px;
}

.pagination {
  width: 98%;
  height: 50px;
  margin-top: 10px;
}

.pagination-main {
  float: right;
  display: flex;
}

.rowsPage {
  height: 30px;
  line-height: 30px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #454d59;
  display: flex;
  margin-left: 10px;
}

.rowsPage-css {
  width: 60px;
  height: 26px;
  line-height: 26px;
  background: #ffffff;
  border: 1px solid #b0bac9;
  box-sizing: border-box;
  padding: 0 5px 0 10px;
  margin-left: 12px;
}

.rowsPage /deep/ .el-dropdown-link {
  width: 45px;
  height: 26px;
  line-height: 26px;
}

.rowsPage /deep/ .el-icon-arrow-down {
  float: right;
  line-height: 26px;
}

.main-css {
  width: 100%;
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
}

.case-num {
  padding: 0 10px;
  height: 24px;
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 4px;
  text-align: center;
  line-height: 22px;
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: -0.02em;
  color: #686868;
  margin-top: 10px;
  float: right;
  margin-left: 5px;
}

.left-box {
  width: 550px;
  min-height: 800px;
  /*float: left;*/
  overflow: hidden;
  padding-bottom: 20px;
  position: relative;
}

.main-left-box {
  width: 100%;
  /* min-height: 830px; */
  overflow-y: auto;
  position: absolute;
  left: 0;
  top: 0;
  right: -17px;
  bottom: 0;
  overflow-x: hidden;
}

.case-name {
  height: 55px;
  width: 100%;
}

.case-name .title {
  width: 440px;
  height: 25px;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  color: #686868;
  border-bottom: 1px solid #686868;
}

.case-name .title-name {
  height: 30px;
  width: 440px;
  font-weight: 500;
  font-size: 18px;
  line-height: 30px;
  color: #686868;
}

.case-img {
  margin-top: 40px;
  width: 100%;
  height: 114px;
  display: flex;
  justify-content: space-between;
}

.case-img img {
  width: 150px;
  height: 114px;
}

.label {
  width: 100%;
  height: 26px;
  margin-top: 20px;
}

.label-box {
  padding: 0 5px;
  background: #b2b2b2;
  border-radius: 4px;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #ffffff;
  float: left;
  margin-right: 20px;
}

.label-box span {
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #fff;
  line-height: 14px;
  color: #b2b2b2;
  text-align: center;
  margin-left: 10px;
  cursor: pointer;
}

.left-button {
  width: 100%;
  height: 41px;
}

.inline-left {
  width: 200px;
  height: 130px;
  margin-right: 45px;
  float: left;
  /*background: #51abff;*/
}

.inline-right {
  width: 240px;
  height: 180px;
  margin-right: 45px;
  float: left;
}

.inline-left-title {
  width: 100%;
  height: 30px;
  line-height: 30px;
  font-weight: 700;
  font-size: 14px;
  color: #686868;
  border-bottom: 1px solid #686868;
  /*background:yellow;*/
}

.inline-box {
  height: 60px;
  width: 100%;
  margin-top: 10px;
}

.inline-log-box {
  margin-top: 10px;
  width: 100%;
  min-height: 120px;
}

.long-box-title {
  min-height: 360px;
  line-height: 30px;
  width: 485px;
  font-weight: 700;
  font-size: 14px;
  color: #686868;
  border-bottom: 1px solid #686868;
}

.long-box-main {
  width: 485px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #686868;
  padding-bottom: 30px;
  /* display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden; */
}

.one-box-left1 {
  width: 200px;
  height: 70%;
  padding-left: 20px;
  padding-top: 5px;
  box-sizing: border-box;
  display: flex;
  justify-content: left;
}

.one-box-left2 {
  width: 600px;
  height: 100px;
  background: #ffffff;
  border-radius: 4px;
  margin: auto;
}

.one-box-left-line1 {
  width: 80%;
  height: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.one-box-left-line2 {
  width: 80%;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.one-box-left-line3 {
  width: 80%;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.one-box-left-line4 {
  width: 80%;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.one-box-left-line-smallleft {
  width: 40%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 800;
  font-size: 15px;
  line-height: 24px;
  /* or 171% */
  display: flex;
  align-items: center;
  /* 灰色字体 */
  color: #686868;
}

.one-box-left-line-smallright {
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  /* or 143% */

  display: flex;
  align-items: center;

  /* 灰色字体 */

  color: #686868;
}

.label-box-active {
  float: left;
  height: 24px;
  padding: 0 5px;
  line-height: 24px;
  background: #51abff;
  border-radius: 4px;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
  overflow: hidden;
  margin-right: 20px;
}

.label-box-active span {
  height: 13px;
  width: 13px;
  background: #fff;
  border-radius: 50%;
  line-height: 13px;
  text-align: center;
  margin-left: 10px;
  display: inline-block;
  color: #b2b2b2;
}

.label-box span {
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #fff;
  line-height: 14px;
  color: #b2b2b2;
  text-align: center;
  margin-left: 10px;
  cursor: pointer;
}

.info-box span {
  position: absolute;
  top: -12px;
  left: 15px;
  display: inline-block;
  height: 24px;
  padding: 0 5px;
  background: #ffffff;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #51abff;
  z-index: 10;
}

.schedule-box span {
  position: absolute;
  top: -12px;
  left: 15px;
  display: inline-block;
  height: 24px;
  padding: 0 5px;
  background: #ffffff;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #51abff;
  z-index: 10;
}

.chat-box-css {
  width: 530px;
  background: #ffffff;
  border: 2px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  margin-top: 10px;
  position: relative;
}

.chat-box-css span {
  position: absolute;
  top: -12px;
  left: 15px;
  display: inline-block;
  height: 24px;
  padding: 0 5px;
  background: #ffffff;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #51abff;
  z-index: 10;
}

.chat-box-css /deep/ .search .el-input__inner {
  background: transparent;
}

.chat-box-css /deep/ .send-message {
  height: 60px;
}

.chat-box-css /deep/ .send-message .el-input__inner {
  border-radius: 0;
  border-bottom: 1px solid #51abff;
}

.main-left-box {
  /* height: 650px; */
  overflow-y: auto;
}

/deep/.el-dialog__body {
  height: 70vh;
  overflow: auto;
}

.el-dropdown-css-1 /deep/ .el-dropdown {
  width: max-content !important;
  margin-top: 5px;
}

.el-dropdown-css-2 /deep/ .el-dropdown {
  width: 130px !important;
  margin-top: 5px;
}

.el-dropdown-css-3 /deep/ .el-dropdown {
  width: 115px !important;
  margin-top: 5px;
  margin-left: 23px;
}

.table /deep/ .caret-wrapper {
  width: 40px;
}
</style>



// WEBPACK FOOTER //
// src/pages/educationalInstitutionTalentListView/index.vue